import React, { Component } from "react";
import {
  Card,
  Tabs,
  List,
  Input,
  Button,
  Typography,
  Radio,
  Divider,
  message,
  Tag,
  notification,
  Checkbox,
  Alert,
} from "antd";
import { QuestionCircleOutlined, SmileOutlined } from "@ant-design/icons";

import { connect } from "react-redux";
import {
  req_single_gqm_graduatealumni,
  req_add_gqm_graduateYearSurvey,
} from "../../api";

const { TabPane } = Tabs;
const { Title, Link, Text, Paragraph } = Typography;

class SurveyFiveYear extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    version: "114.04修正",
    yearSurvey: "5",
    testYear: "", //108
    participantId: "",
    participantName: "",
    tabPosition: "left",
    tabActive: "OO",
    investigations: [
      {
        sortvalue: 0,
        tabname: "說明",
        label: "OO",
        answertype: "text",
        answerlimit: 1,
        question: "流向追蹤問卷調查",
        description: "",
        answer: "",
        supplementanswer: "",
        selffill: "",
        disabled: true,
      },
      {
        sortvalue: 1,
        tabname: "題目1",
        label: "AA",
        answertype: "singlechoice",
        answerlimit: 1,
        question:
          "您目前的工作狀況為何（不包括留職停薪、育嬰假，請依主要薪水來源作答）？",
        description:
          "（同時為「全職工作者與部分工時者」，請以最主要工作狀況填報以下問項）",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 2,
        tabname: "題目2",
        label: "AB",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您目前服務的部門別(請畢業生填報最相似的工作服務部門)？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 3,
        tabname: "題目3",
        label: "AC",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您目前是否擔任主管？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 4,
        tabname: "題目4",
        label: "AD",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您目前最主要的工作行業類別為？",
        description:
          "（例如計程車司機請勾「運輸及倉儲業」，但在醫院開救護車者，請勾選「醫療保護及社會工作服務業」…等）",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 5,
        tabname: "題目5",
        label: "AF",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您現在工作平均每月收入為何？",
        description:
          "(請回答課稅前固定（經常）性收入，係指固定津貼、交通費、膳食費、水電費、按月發放之工作（生產、績效、業績）獎金及全勤獎金等)",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 6,
        tabname: "題目6",
        label: "AG",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "請問您現在主要的工作所在地點為何？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 7,
        tabname: "題目7",
        label: "AH",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您目前未就業的原因為何？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 8,
        tabname: "題目8",
        label: "AI",
        answertype: "singlechoice",
        answerlimit: 1,
        question:
          "您原先就讀系、所、或學位學程的專業訓練課程，對於您目前工作的幫助程度為何？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 9,
        tabname: "題目9",
        label: "AJ",
        answertype: "manychoice",
        answerlimit: 3,
        question: "您在學期間以下哪些「學習經驗」對於現在工作有所幫助？",
        description: "(可複選，至多3項)",
        answer: [],
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 10,
        tabname: "題目10",
        label: "AK",
        answertype: "manychoice",
        answerlimit: 3,
        question:
          "根據您畢業到現在的經驗，學校最應該幫學弟妹加強以下哪些能力？",
        description: "(可複選，至多3項)",
        answer: [],
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 11,
        tabname: "題目11",
        label: "AL",
        answertype: "manychoice",
        answerlimit: 3,
        question:
          "根據您畢業後到現在的經驗，您認為學校對您那些能力的培養最有幫助？",
        description: "(可複選，至多3項)",
        answer: [],
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 12,
        tabname: "題目12",
        label: "AM",
        answertype: "singlechoice",
        answerlimit: 1,
        question:
          "如果您現在有進修機會的話，「最」想在學校進修的是哪一個學門？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 13,
        tabname: "結束",
        label: "AN",
        answertype: "text",
        answerlimit: 1,
        question: "謝謝您的填答",
        description: "",
        answer: "",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
    ],
    surveys: [
      {
        label: "AA",
        children: [
          {
            scopevalue: "5A",
            keyvalue: 1,
            groupvalue: "A",
            content: "企業（包括民營企業或國營企業…等）",
            choicevalue: "5A1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 2,
            groupvalue: "A",
            content: "政府部門（包括職業軍人）",
            choicevalue: "5A2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 3,
            groupvalue: "A",
            content: "學校（包括公立及私立大學、高中、高職、國中小…等）",
            choicevalue: "5A3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 4,
            groupvalue: "A",
            content: "非營利機構",
            choicevalue: "5A4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 5,
            groupvalue: "A",
            content: "創業",
            choicevalue: "5A5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 6,
            groupvalue: "A",
            content: "自由工作者(以接案維生或個人服務，例如撰稿人…)",
            choicevalue: "5A6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 7,
            groupvalue: "A",
            content: "其他",
            choicevalue: "5A7",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 8,
            groupvalue: "B1",
            content: "請問您1週工作時數約",
            choicevalue: "5A8",
            canselffill: "Y",
            selffilldescription: "小時",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 9,
            groupvalue: "B2",
            content: "企業（包括民營企業或國營企業…等）",
            choicevalue: "5A9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 10,
            groupvalue: "B2",
            content: "政府部門（包括職業軍人）",
            choicevalue: "5A10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 11,
            groupvalue: "B2",
            content: "學校（包括公立及私立大學、高中、高職、國中小…等）",
            choicevalue: "5A11",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 12,
            groupvalue: "B2",
            content: "非營利機構",
            choicevalue: "5A12",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 13,
            groupvalue: "B2",
            content: "創業",
            choicevalue: "5A13",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 14,
            groupvalue: "B2",
            content: "自由工作者(以接案維生或個人服務，例如撰稿人…)",
            choicevalue: "5A14",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 15,
            groupvalue: "B2",
            content: "其他",
            choicevalue: "5A15",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 16,
            groupvalue: "C",
            content: "家管/料理家務者",
            choicevalue: "5A16",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5A",
            keyvalue: 17,
            groupvalue: "D",
            content: "目前非就業中",
            choicevalue: "5A17",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
        ],
      },
      {
        label: "AB",
        children: [
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "教育訓練部門",
            choicevalue: "5B1",
            canselffill: "N",
            selffilldescription: "",
            description: "包括學校教師等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "行政部門",
            choicevalue: "5B2",
            canselffill: "N",
            selffilldescription: "",
            description:
              "包括秘書處、管理部、機要部、教育局(處)、高等教育司、綜合業務處、外交國防法務處等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "業務部門",
            choicevalue: "5B3",
            canselffill: "N",
            selffilldescription: "",
            description: "包括事業部等",
            details: [],
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "企劃/行銷部門",
            choicevalue: "5B4",
            canselffill: "N",
            selffilldescription: "",
            description: "包括行銷部、行銷企劃部、活動部等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "研發/開發部門",
            choicevalue: "5B5",
            canselffill: "N",
            selffilldescription: "",
            description:
              "包括軟/硬體研發部、開發部、研發中心、開發部門、行銷部門、研究發展處等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "設計部門",
            choicevalue: "5B6",
            canselffill: "N",
            selffilldescription: "",
            description: "包括設計工程部、設計研發部等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "人力資源/培訓部門",
            choicevalue: "5B7",
            canselffill: "N",
            selffilldescription: "",
            description: "包括人力資源部、人事處、培訓部門等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "生產/製造部門",
            choicevalue: "5B8",
            canselffill: "N",
            selffilldescription: "",
            description: "包括生產管理部、製造部門等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "工程部門",
            choicevalue: "5B9",
            canselffill: "N",
            selffilldescription: "",
            description: "包括製程部門等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "營業(運)部門",
            choicevalue: "5B10",
            canselffill: "N",
            selffilldescription: "",
            description: "包括營業企劃部等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "品保部門",
            choicevalue: "5B11",
            canselffill: "N",
            selffilldescription: "",
            description: "包括品保、品管部門等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "物流部門",
            choicevalue: "5B12",
            canselffill: "N",
            selffilldescription: "",
            description: "包括船務部、車櫃聯運部等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "市場調查部門",
            choicevalue: "5B13",
            canselffill: "N",
            selffilldescription: "",
            description: "包括市場研究部等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "公關部門",
            choicevalue: "5B14",
            canselffill: "N",
            selffilldescription: "",
            description: "包括新聞部門、媒體等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "財務/會計部門",
            choicevalue: "5B15",
            canselffill: "N",
            selffilldescription: "",
            description:
              "包括記帳部、會計部、會計處、財務企劃部、財會部、審計部門、財務管理處等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "採購部門",
            choicevalue: "5B16",
            canselffill: "N",
            selffilldescription: "",
            description: "包括總務部、總務處等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "統計部門",
            choicevalue: "5B17",
            canselffill: "N",
            selffilldescription: "",
            description: "包括統計處、主計處等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "法務部門",
            choicevalue: "5B18",
            canselffill: "N",
            selffilldescription: "",
            description: "包括法制處、法務室、政風處等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "資訊部門",
            choicevalue: "5B19",
            canselffill: "N",
            selffilldescription: "",
            description:
              "包括行銷資訊部、程式設計部門、資訊安全部門、資安部門、資訊處等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "客服部門",
            choicevalue: "5B20",
            canselffill: "N",
            selffilldescription: "",
            description: "包括客服中心等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "稽核部門",
            choicevalue: "5B21",
            canselffill: "N",
            selffilldescription: "",
            description: "包含政風處、稽核室等",
            details: [],
            version: "114.04修正",
          },
          {
            scopevalue: "5B",
            keyvalue: 1,
            groupvalue: "default",
            content: "其他部門",
            choicevalue: "5B22",
            canselffill: "Y",
            selffilldescription: "",
            description: "請敘明部門名稱",
            details: [],
            version: "114.04修正",
          },
        ],
      },
      {
        label: "AC",
        children: [
          {
            scopevalue: "5C",
            keyvalue: 1,
            groupvalue: "default",
            content: "是，管理",
            choicevalue: "5C1",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5C",
            keyvalue: 2,
            groupvalue: "default",
            content: "否",
            choicevalue: "5C2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
        ],
      },
      {
        label: "AD",
        children: [
          {
            scopevalue: "5D",
            keyvalue: 1,
            groupvalue: "default",
            content: "農、林、漁、牧業",
            choicevalue: "5D1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 2,
            groupvalue: "default",
            content: "礦業及土石採取業",
            choicevalue: "5D2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 3,
            groupvalue: "default",
            content: "製造業",
            choicevalue: "5D3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 4,
            groupvalue: "default",
            content: "電力及燃氣供應業",
            choicevalue: "5D4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 5,
            groupvalue: "default",
            content: "用水供應及污染整治業",
            choicevalue: "5D5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 6,
            groupvalue: "default",
            content: "營建工程業",
            choicevalue: "5D6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 7,
            groupvalue: "default",
            content: "批發及零售業",
            choicevalue: "5D7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 8,
            groupvalue: "default",
            content: "運輸及倉儲業",
            choicevalue: "5D8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 9,
            groupvalue: "default",
            content: "住宿及餐飲業",
            choicevalue: "5D9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 10,
            groupvalue: "default",
            content: "出版、影音製作、傳播及資通訊服務業",
            choicevalue: "5D10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 11,
            groupvalue: "default",
            content: "金融及保險業",
            choicevalue: "5D11",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 12,
            groupvalue: "default",
            content: "不動產業",
            choicevalue: "5D12",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 13,
            groupvalue: "default",
            content: "專業、科學及技術服務業",
            choicevalue: "5D13",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 14,
            groupvalue: "default",
            content: "支援服務業",
            choicevalue: "5D14",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 15,
            groupvalue: "default",
            content: "公共行政及國防、強制性社會安全",
            choicevalue: "5D15",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 16,
            groupvalue: "default",
            content: "教育業",
            choicevalue: "5D16",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 17,
            groupvalue: "default",
            content: "醫療保健及社會工作服務業",
            choicevalue: "5D17",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 18,
            groupvalue: "default",
            content: "藝術、娛樂及休閒服務業",
            choicevalue: "5D18",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5D",
            keyvalue: 19,
            groupvalue: "default",
            content: "其他服務業",
            choicevalue: "5D19",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
        ],
      },
      {
        label: "AF",
        children: [
          {
            scopevalue: "5F",
            keyvalue: 1,
            groupvalue: "default",
            content: "約新臺幣22,000元以下",
            choicevalue: "5F1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 2,
            groupvalue: "default",
            content: "約新臺幣22,001元至25,000元",
            choicevalue: "5F2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 3,
            groupvalue: "default",
            content: "約新臺幣25,001元至28,000元",
            choicevalue: "5F3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 4,
            groupvalue: "default",
            content: "約新臺幣28,001元至31,000元",
            choicevalue: "5F4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 5,
            groupvalue: "default",
            content: "約新臺幣31,001元至34,000元",
            choicevalue: "5F5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 6,
            groupvalue: "default",
            content: "約新臺幣34,001元至37,000元",
            choicevalue: "5F6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 7,
            groupvalue: "default",
            content: "約新臺幣37,001元至40,000元",
            choicevalue: "5F7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 8,
            groupvalue: "default",
            content: "約新臺幣40,001元至43,000元",
            choicevalue: "5F8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 9,
            groupvalue: "default",
            content: "約新臺幣43,001元至46,000元",
            choicevalue: "5F9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 10,
            groupvalue: "default",
            content: "約新臺幣46,001元至49,000元",
            choicevalue: "5F10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 11,
            groupvalue: "default",
            content: "約新臺幣49,001元至52,000元",
            choicevalue: "5F11",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 12,
            groupvalue: "default",
            content: "約新臺幣52,001元至55,000元",
            choicevalue: "5F12",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 13,
            groupvalue: "default",
            content: "約新臺幣55,001元至60,000元",
            choicevalue: "5F13",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 14,
            groupvalue: "default",
            content: "約新臺幣60,001元至65,000元",
            choicevalue: "5F14",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 15,
            groupvalue: "default",
            content: "約新臺幣65,001元至70,000元",
            choicevalue: "5F15",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 16,
            groupvalue: "default",
            content: "約新臺幣70,001元至75,000元",
            choicevalue: "5F16",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 17,
            groupvalue: "default",
            content: "約新臺幣75,001元至80,000元",
            choicevalue: "5F17",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 18,
            groupvalue: "default",
            content: "約新臺幣80,001元至85,000元",
            choicevalue: "5F18",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 19,
            groupvalue: "default",
            content: "約新臺幣85,001元至90,000元",
            choicevalue: "5F19",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 20,
            groupvalue: "default",
            content: "約新臺幣90,001元至95,000元",
            choicevalue: "5F20",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 21,
            groupvalue: "default",
            content: "約新臺幣95,001元至100,000元",
            choicevalue: "5F21",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 22,
            groupvalue: "default",
            content: "約新臺幣100,001元至110,000元",
            choicevalue: "5F22",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 23,
            groupvalue: "default",
            content: "約新臺幣110,001元至120,000元",
            choicevalue: "5F23",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 24,
            groupvalue: "default",
            content: "約新臺幣120,001元至130,000元",
            choicevalue: "5F24",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 25,
            groupvalue: "default",
            content: "約新臺幣130,001元至140,000元",
            choicevalue: "5F25",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 26,
            groupvalue: "default",
            content: "約新臺幣140,001元至150,000元",
            choicevalue: "5F26",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 27,
            groupvalue: "default",
            content: "約新臺幣150,001元至170,000元",
            choicevalue: "5F27",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 28,
            groupvalue: "default",
            content: "約新臺幣170,001元至190,000元",
            choicevalue: "5F28",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 29,
            groupvalue: "default",
            content: "約新臺幣190,001元至210,000元",
            choicevalue: "5F29",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5F",
            keyvalue: 30,
            groupvalue: "default",
            content: "約新臺幣210,001元以上",
            choicevalue: "5F30",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
        ],
      },
      {
        label: "AG",
        children: [
          {
            scopevalue: "5G",
            keyvalue: 1,
            groupvalue: "A",
            content: "基隆市",
            choicevalue: "5G1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 2,
            groupvalue: "A",
            content: "新北市",
            choicevalue: "5G2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 3,
            groupvalue: "A",
            content: "台北市",
            choicevalue: "5G3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 4,
            groupvalue: "A",
            content: "桃園市",
            choicevalue: "5G4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 5,
            groupvalue: "A",
            content: "新竹縣",
            choicevalue: "5G5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 6,
            groupvalue: "A",
            content: "新竹市",
            choicevalue: "5G6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 7,
            groupvalue: "A",
            content: "苗栗縣",
            choicevalue: "5G7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 8,
            groupvalue: "B",
            content: "台中市",
            choicevalue: "5G8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 9,
            groupvalue: "B",
            content: "南投縣",
            choicevalue: "5G9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 10,
            groupvalue: "B",
            content: "彰化縣",
            choicevalue: "5G10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 11,
            groupvalue: "B",
            content: "雲林縣",
            choicevalue: "5G11",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 12,
            groupvalue: "B",
            content: "嘉義縣",
            choicevalue: "5G12",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 13,
            groupvalue: "B",
            content: "嘉義市",
            choicevalue: "5G13",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 14,
            groupvalue: "C",
            content: "台南市",
            choicevalue: "5G14",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 15,
            groupvalue: "C",
            content: "高雄市",
            choicevalue: "5G15",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 16,
            groupvalue: "C",
            content: "屏東縣",
            choicevalue: "5G16",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 17,
            groupvalue: "D",
            content: "台東縣",
            choicevalue: "5G17",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 18,
            groupvalue: "D",
            content: "花蓮縣",
            choicevalue: "5G18",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 19,
            groupvalue: "D",
            content: "宜蘭縣",
            choicevalue: "5G19",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 20,
            groupvalue: "D",
            content: "連江縣",
            choicevalue: "5G20",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 21,
            groupvalue: "D",
            content: "金門縣",
            choicevalue: "5G21",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 22,
            groupvalue: "D",
            content: "澎湖縣",
            choicevalue: "5G22",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 23,
            groupvalue: "E",
            content: "亞洲（香港、澳門、大陸地區）",
            choicevalue: "5G23",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 24,
            groupvalue: "E",
            content: "亞洲（香港、澳門、大陸地區以外國家）",
            choicevalue: "5G24",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 25,
            groupvalue: "E",
            content: "大洋洲",
            choicevalue: "5G25",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 26,
            groupvalue: "E",
            content: "非洲",
            choicevalue: "5G26",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 27,
            groupvalue: "E",
            content: "歐洲",
            choicevalue: "5G27",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 28,
            groupvalue: "E",
            content: "北美洲",
            choicevalue: "5G28",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 29,
            groupvalue: "E",
            content: "中美洲",
            choicevalue: "5G29",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5G",
            keyvalue: 30,
            groupvalue: "E",
            content: "南美洲",
            choicevalue: "5G30",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
        ],
      },
      {
        label: "AH",
        children: [
          {
            scopevalue: "5H",
            keyvalue: 1,
            groupvalue: "A",
            content: "進修中",
            choicevalue: "5H1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 2,
            groupvalue: "B",
            content: "服役中或等待服役中",
            choicevalue: "5H2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 3,
            groupvalue: "C",
            content: "國內研究所",
            choicevalue: "5H3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 4,
            groupvalue: "C",
            content: "出國留學",
            choicevalue: "5H4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 5,
            groupvalue: "C",
            content: "證照",
            choicevalue: "5H5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 6,
            groupvalue: "C",
            content: "公務人員",
            choicevalue: "5H6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 7,
            groupvalue: "C",
            content: "其他",
            choicevalue: "5H7",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 8,
            groupvalue: "D1",
            content: "沒有工作機會",
            choicevalue: "5H8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 9,
            groupvalue: "D1",
            content: "薪水不滿意",
            choicevalue: "5H9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 11,
            groupvalue: "D1",
            content: "公司財務或制度不穩健",
            choicevalue: "5H10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 12,
            groupvalue: "D1",
            content: "工作地點不適合",
            choicevalue: "5H11",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 13,
            groupvalue: "D1",
            content: "與所學不符",
            choicevalue: "5H12",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 14,
            groupvalue: "D1",
            content: "不符合家人的期望",
            choicevalue: "5H13",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 15,
            groupvalue: "D1",
            content: "工作內容不滿意",
            choicevalue: "5H14",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 16,
            groupvalue: "D1",
            content: "其他",
            choicevalue: "5H15",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 17,
            groupvalue: "D2",
            content: "約1個月以內",
            choicevalue: "5H16",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 18,
            groupvalue: "D2",
            content: "約1個月以上至2個月內",
            choicevalue: "5H17",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 19,
            groupvalue: "D2",
            content: "約2個月以上至3個月內",
            choicevalue: "5H18",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 21,
            groupvalue: "D2",
            content: "約3個月以上至4個月內",
            choicevalue: "5H19",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 22,
            groupvalue: "D2",
            content: "約4個月以上至6個月內",
            choicevalue: "5H20",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 23,
            groupvalue: "D2",
            content: "約6個月以上",
            choicevalue: "5H21",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5H",
            keyvalue: 24,
            groupvalue: "E",
            content: "不想找工作、生病…",
            choicevalue: "5H22",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
        ],
      },
      {
        label: "AI",
        children: [
          {
            scopevalue: "5I",
            keyvalue: 1,
            groupvalue: "default",
            content: "非常有幫助",
            choicevalue: "5I1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5I",
            keyvalue: 2,
            groupvalue: "default",
            content: "有點幫助",
            choicevalue: "5I2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5I",
            keyvalue: 3,
            groupvalue: "default",
            content: "普通",
            choicevalue: "5I3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5I",
            keyvalue: 4,
            groupvalue: "default",
            content: "沒有幫助",
            choicevalue: "5I4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5I",
            keyvalue: 5,
            groupvalue: "default",
            content: "完全沒有幫助",
            choicevalue: "5I5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
        ],
      },
      {
        label: "AJ",
        children: [
          {
            scopevalue: "5J",
            keyvalue: 1,
            groupvalue: "default",
            content: "專業知識、知能傳授",
            choicevalue: "5J1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5J",
            keyvalue: 2,
            groupvalue: "default",
            content: "建立同學及老師人脈",
            choicevalue: "5J2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5J",
            keyvalue: 3,
            groupvalue: "default",
            content: "校內實務課程",
            choicevalue: "5J3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5J",
            keyvalue: 4,
            groupvalue: "default",
            content: "校外業界實習",
            choicevalue: "5J4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5J",
            keyvalue: 5,
            groupvalue: "default",
            content: "社團活動",
            choicevalue: "5J5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5J",
            keyvalue: 6,
            groupvalue: "default",
            content: "語言學習",
            choicevalue: "5J6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5J",
            keyvalue: 7,
            groupvalue: "default",
            content: "參與國際交流活動",
            choicevalue: "5J7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5J",
            keyvalue: 8,
            groupvalue: "default",
            content: "志工服務、服務學習",
            choicevalue: "5J8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5J",
            keyvalue: 9,
            groupvalue: "default",
            content: "擔任研究或教學助理",
            choicevalue: "5J9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5J",
            keyvalue: 10,
            groupvalue: "default",
            content: "其他訓練",
            choicevalue: "5J10",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
        ],
      },
      {
        label: "AK",
        children: [
          {
            scopevalue: "5K",
            keyvalue: 1,
            groupvalue: "default",
            content: "溝通表達能力",
            choicevalue: "5K1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5K",
            keyvalue: 2,
            groupvalue: "default",
            content: "持續學習能力",
            choicevalue: "5K2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5K",
            keyvalue: 3,
            groupvalue: "default",
            content: "人際互動能力",
            choicevalue: "5K3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5K",
            keyvalue: 4,
            groupvalue: "default",
            content: "團隊合作能力",
            choicevalue: "5K4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5K",
            keyvalue: 5,
            groupvalue: "default",
            content: "問題解決能力",
            choicevalue: "5K5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5K",
            keyvalue: 6,
            groupvalue: "default",
            content: "創新能力",
            choicevalue: "5K6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5K",
            keyvalue: 7,
            groupvalue: "default",
            content: "工作紀律、責任感及時間管理能力",
            choicevalue: "5K7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5K",
            keyvalue: 8,
            groupvalue: "default",
            content: "資訊科技應用能力",
            choicevalue: "5K8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5K",
            keyvalue: 9,
            groupvalue: "default",
            content: "外語能力",
            choicevalue: "5K9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5K",
            keyvalue: 10,
            groupvalue: "default",
            content: "跨領域整合能力",
            choicevalue: "5K10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5K",
            keyvalue: 11,
            groupvalue: "default",
            content: "領導能力",
            choicevalue: "5K11",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5K",
            keyvalue: 12,
            groupvalue: "default",
            content: "其他",
            choicevalue: "5K12",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
        ],
      },
      {
        label: "AL",
        children: [
          {
            scopevalue: "5L",
            keyvalue: 1,
            groupvalue: "default",
            content: "溝通表達能力",
            choicevalue: "5L1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5L",
            keyvalue: 2,
            groupvalue: "default",
            content: "持續學習能力",
            choicevalue: "5L2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5L",
            keyvalue: 3,
            groupvalue: "default",
            content: "人際互動能力",
            choicevalue: "5L3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5L",
            keyvalue: 4,
            groupvalue: "default",
            content: "團隊合作能力",
            choicevalue: "5L4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5L",
            keyvalue: 5,
            groupvalue: "default",
            content: "問題解決能力",
            choicevalue: "5L5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5L",
            keyvalue: 6,
            groupvalue: "default",
            content: "創新能力",
            choicevalue: "5L6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5L",
            keyvalue: 7,
            groupvalue: "default",
            content: "工作紀律、責任感及時間管理能力",
            choicevalue: "5L7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5L",
            keyvalue: 8,
            groupvalue: "default",
            content: "資訊科技應用能力",
            choicevalue: "5L8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5L",
            keyvalue: 9,
            groupvalue: "default",
            content: "外語能力",
            choicevalue: "5L9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5L",
            keyvalue: 10,
            groupvalue: "default",
            content: "跨領域整合能力",
            choicevalue: "5L10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5L",
            keyvalue: 11,
            groupvalue: "default",
            content: "領導能力",
            choicevalue: "5L11",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
          {
            scopevalue: "5L",
            keyvalue: 12,
            groupvalue: "default",
            content: "其他",
            choicevalue: "5L12",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "114.04修正",
          },
        ],
      },
      {
        label: "AM",
        children: [
          {
            scopevalue: "5M",
            keyvalue: 1,
            groupvalue: "default",
            content: "教育學門",
            choicevalue: "5M1",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 2,
            groupvalue: "default",
            content: "藝術學門",
            choicevalue: "5M2",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 3,
            groupvalue: "default",
            content: "人文學門",
            choicevalue: "5M3",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 4,
            groupvalue: "default",
            content: "設計學門",
            choicevalue: "5M4",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 5,
            groupvalue: "default",
            content: "社會及行為科學學門",
            choicevalue: "5M5",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 6,
            groupvalue: "default",
            content: "傳播學門",
            choicevalue: "5M6",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 7,
            groupvalue: "default",
            content: "商業及管理學門",
            choicevalue: "5M7",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 8,
            groupvalue: "default",
            content: "法律學門",
            choicevalue: "5M8",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 9,
            groupvalue: "default",
            content: "生命科學學門",
            choicevalue: "5M9",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 10,
            groupvalue: "default",
            content: "自然科學學門",
            choicevalue: "5M10",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 11,
            groupvalue: "default",
            content: "數學及統計學門",
            choicevalue: "5M11",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 12,
            groupvalue: "default",
            content: "電算機學門",
            choicevalue: "5M12",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 13,
            groupvalue: "default",
            content: "工程學門",
            choicevalue: "5M13",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 14,
            groupvalue: "default",
            content: "建築及都市規劃學門",
            choicevalue: "5M14",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 15,
            groupvalue: "default",
            content: "農業科學學門",
            choicevalue: "5M15",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 16,
            groupvalue: "default",
            content: "獸醫學門",
            choicevalue: "5M16",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 17,
            groupvalue: "default",
            content: "醫藥衛生學門",
            choicevalue: "5M17",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 18,
            groupvalue: "default",
            content: "社會服務學門",
            choicevalue: "5M18",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 19,
            groupvalue: "default",
            content: "民生學門",
            choicevalue: "5M19",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 20,
            groupvalue: "default",
            content: "運輸服務學門",
            choicevalue: "5M20",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 21,
            groupvalue: "default",
            content: "環境保護學門",
            choicevalue: "5M21",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 22,
            groupvalue: "default",
            content: "軍警國防安全學門",
            choicevalue: "5M22",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 23,
            groupvalue: "default",
            content: "其他學門",
            choicevalue: "5M23",
            canselffill: "N",
            details: [],
            description: "",
          },
          {
            scopevalue: "5M",
            keyvalue: 24,
            groupvalue: "default",
            content: "沒有進修需求",
            choicevalue: "5M24",
            canselffill: "N",
            details: [],
            description: "",
          },
        ],
      },
    ],
  };

  UNSAFE_componentWillMount() {
    this.api_single_row();
  }
  // 遠端數據處理 //////////////////////////////////////////////

  api_add_row = async (reply) => {
    const item = reply;
    const { token, userCode, userName } = this.props.user;
    // 填單為自己
    item.RecordCreateOperator = userCode + ";" + userName;
    item.ActualCounselorCode = "";
    item.ActualCounselorName = "";

    const result = await req_add_gqm_graduateYearSurvey(item, token);

    if (result.status === "success") {
      //message.success(result.message)
      message.success("問卷完成，謝謝您配合");
    } else {
      message.error(result.message);
    }
  };

  api_single_row = async () => {
    const { token, userCode } = this.props.user;
    const { yearSurvey } = this.state;
    const result = await req_single_gqm_graduatealumni(
      userCode,
      yearSurvey,
      token
    );

    if (result) {
      //有數據-判斷是否已經做完問卷
      if (result.NumFiveYearSurvey > 0) {
        notification.open({
          message: "提示",
          description:
            "親愛的校友您好，您已經填寫過本問卷，若重填僅會覆蓋前一次結果",
          icon: <SmileOutlined style={{ color: "#108ee9" }} />,
        });
        this.init_values(result);
      } else {
        this.init_values(result);
      }
    } else {
      //沒數據-目前非納入調查範圍
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_values = (item) => {
    // console.log(this.props.alumni)
    const { YearGrade, StudentId, StudentName } = item;
    this.setState({
      testYear: YearGrade,
      participantId: StudentId,
      participantName: StudentName,
    });
  };

  handle_set_value = (num, field, value) => {
    let items = [...this.state.investigations];
    let index = items.findIndex((element) => element.label === num);
    let item = { ...items[index] };
    switch (field) {
      case "answer":
        item.answer = value;
        break;
      case "supplementanswer":
        item.supplementanswer = value;
        break;
      case "disabled":
        item.disabled = value;
        break;
      case "selffill":
        item.selffill = value;
        break;
      default:
    }
    items[index] = item;
    this.setState({ investigations: items });
    //console.log(this.state.investigations)
  };

  handle_get_value = (num, field) => {
    let value = "";
    let items = [...this.state.investigations];
    let index = items.findIndex((element) => element.label === num);
    let item = { ...items[index] };
    switch (field) {
      case "answer":
        value = item.answer;
        break;
      case "supplementanswer":
        value = item.supplementanswer;
        break;
      case "selffill":
        value = item.selffill;
        break;
      default:
    }
    return value;
  };

  handle_get_surveys_content = (questioncode, choicevalue) => {
    ///console.log(questioncode, choicevalue)
    let value = "";
    let items = [...this.state.surveys];
    let index = items.findIndex((element) => element.label === questioncode);
    let options = [...items[index].children];
    //console.log('options:', options)
    let selected = options.findIndex(
      (element) => element.choicevalue === choicevalue
    );
    let item = { ...options[selected] };
    //console.log('item:', item)
    value = item.content;
    //console.log('value:', value)
    return value;
  };

  get_list_options = (label) => {
    const data = this.state.surveys.find((item, index) => {
      return item.label === label ? true : false;
    });
    return data.children;
  };

  handle_reply_verification = () => {
    //console.log(items)
    const yearSurvey = this.state.yearSurvey;
    const year = this.state.testYear;
    const version = this.state.version;
    const alumniCode = this.state.participantId;
    const alumniName = this.state.participantName;

    const alumnireply = {
      Version: "",

      YearSurvey: "",
      YearGrade: "",

      AlumniCode: "",
      AlumniName: "",
      RecordCreateOperator: "",

      QuestionAA: "",
      AnswerAA: "",
      ValueAA: "",

      QuestionAB: "",
      AnswerAB: "",
      ValueAB: "",

      QuestionAC: "",
      AnswerAC: "",
      ValueAC: "",

      QuestionAD: "",
      AnswerAD: "",
      ValueAD: "",

      //QuestionAE: '',
      //AnswerAE: '',
      //ValueAE: '',

      QuestionAF: "",
      AnswerAF: "",
      ValueAF: "",

      QuestionAG: "",
      AnswerAG: "",
      ValueAG: "",

      QuestionAH: "",
      AnswerAH: "",
      ValueAH: "",

      QuestionAI: "",
      AnswerAI: "",
      ValueAI: "",

      QuestionAJ: "",
      AnswerAJ: "",
      ValueAJ: "",

      QuestionAK: "",
      AnswerAK: "",
      ValueAK: "",

      QuestionAL: "",
      AnswerAL: "",
      ValueAL: "",

      QuestionAM: "",
      AnswerAM: "",
      ValueAM: "",
    };
    alumnireply.YearSurvey = yearSurvey;
    alumnireply.YearGrade = year;
    alumnireply.Version = version;
    alumnireply.AlumniCode = alumniCode;
    alumnireply.AlumniName = alumniName;

    this.state.investigations.forEach((item, i, array) => {
      // console.log(item);
      alumnireply["Question" + item["label"]] = item.question;
      switch (item["label"]) {
        case "AA":
          if (
            item.answer === "5A9" ||
            item.answer === "5A10" ||
            item.answer === "5A11" ||
            item.answer === "5A12" ||
            item.answer === "5A13" ||
            item.answer === "5A14"
          ) {
            alumnireply["Value" + item["label"]] =
              year + "5A8;" + item.supplementanswer + "@" + year + item.answer;
          } else if (item.answer === "5A15") {
            alumnireply["Value" + item["label"]] =
              year +
              "5A8;" +
              item.supplementanswer +
              "@" +
              year +
              item.answer +
              ";" +
              item.selffill;
          } else if (item.answer === "5A7") {
            alumnireply["Value" + item["label"]] =
              year + item.answer + ";" + item.selffill;
          } else {
            alumnireply["Value" + item["label"]] = year + item.answer;
          }
          alumnireply["Answer" + item["label"]] =
            this.handle_get_surveys_content(item["label"], item.answer) || "";
          break;
        case "AB":
        case "AC":
        case "AG":
          if (
            item.answer === "5B22" ||
            item.answer === "5C1" ||
            item.answer === "5G23" ||
            item.answer === "5G24" ||
            item.answer === "5G25" ||
            item.answer === "5G26" ||
            item.answer === "5G27" ||
            item.answer === "5G28" ||
            item.answer === "5G29" ||
            item.answer === "5G30"
          ) {
            alumnireply["Value" + item["label"]] =
              year + item.answer + ";" + item.selffill;
          } else {
            alumnireply["Value" + item["label"]] = year + item.answer;
          }
          alumnireply["Answer" + item["label"]] =
            this.handle_get_surveys_content(item["label"], item.answer) || "";
          break;
        case "AD":
        case "AF":
        case "AI":
        case "AM":
          alumnireply["Value" + item["label"]] = year + item.answer;
          alumnireply["Answer" + item["label"]] =
            this.handle_get_surveys_content(item["label"], item.answer) || "";
          break;
        case "AH":
          if (
            item.answer === "5H8" ||
            item.answer === "5H9" ||
            item.answer === "5H10" ||
            item.answer === "5H11" ||
            item.answer === "5H12" ||
            item.answer === "5H13" ||
            item.answer === "5H14" ||
            item.answer === "5H15"
          ) {
            if (item.answer === "5H15") {
              alumnireply["Value" + item["label"]] =
                year +
                item.answer +
                ";" +
                item.selffill +
                "@" +
                year +
                item.supplementanswer;
            } else {
              alumnireply["Value" + item["label"]] =
                year + item.answer + "@" + year + item.supplementanswer;
            }
          } else {
            if (item.answer === "5H7" || item.answer === "5H22") {
              alumnireply["Value" + item["label"]] =
                year + item.answer + ";" + item.selffill;
            } else {
              alumnireply["Value" + item["label"]] = year + item.answer;
            }
          }
          alumnireply["Answer" + item["label"]] =
            this.handle_get_surveys_content(item["label"], item.answer) || "";
          break;
        case "AJ":
        case "AK":
        case "AL":
          if (item.answer.length > 0) {
            if (
              item.answer.indexOf("5J10") > -1 ||
              item.answer.indexOf("5K12") > -1 ||
              item.answer.indexOf("5L12") > -1
            ) {
              alumnireply["Value" + item["label"]] =
                item.answer
                  .map((element) => {
                    return year + element;
                  })
                  .sort((a, b) => {
                    var numA = parseInt(a.substring(5), 10);
                    var numB = parseInt(b.substring(5), 10);
                    if (numA < numB) {
                      return -1;
                    }
                    if (numA > numB) {
                      return 1;
                    }
                    return 0;
                  })
                  .join("@") +
                ";" +
                item.selffill;
              alumnireply["Answer" + item["label"]] = item.answer
                .map((element) => {
                  return this.handle_get_surveys_content(
                    item["label"],
                    element
                  );
                })
                .join(";");
            } else {
              alumnireply["Value" + item["label"]] = item.answer
                .map((element) => {
                  return year + element;
                })
                .sort()
                .join("@");
              alumnireply["Answer" + item["label"]] = item.answer
                .map((element) => {
                  return this.handle_get_surveys_content(
                    item["label"],
                    element
                  );
                })
                .join(";");
            }
          }
          break;
        default:
      }
    });

    Object.keys(alumnireply).forEach((key) => {
      if (alumnireply[key] === year + "-1") {
        alumnireply[key] = "";
      }
    });

    if (this.state.investigations[1]["answer"] === "5A16") {
      Object.keys(alumnireply).forEach((key) => {
        if (key.indexOf("Value") > -1) {
          if (
            key === "ValueAA" ||
            key === "ValueAK" ||
            key === "ValueAL" ||
            key === "ValueAM"
          ) {
          } else {
            alumnireply[key] = "";
          }
        }
      });
    } else if (this.state.investigations[1]["answer"] === "5A17") {
      Object.keys(alumnireply).forEach((key) => {
        if (key.indexOf("Value") > -1) {
          if (
            key === "ValueAA" ||
            key === "ValueAH" ||
            key === "ValueAK" ||
            key === "ValueAL" ||
            key === "ValueAM"
          ) {
          } else {
            alumnireply[key] = "";
          }
        }
      });
    } else {
      Object.keys(alumnireply).forEach((key) => {
        if (key.indexOf("Value") > -1) {
          if (key === "ValueAH") {
            alumnireply[key] = "";
          }
        }
      });
    }
    this.api_add_row(alumnireply);
    //console.log(alumnireply)
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_ui_tab_process = (currentPage, value) => {
    var nextPage = currentPage;
    switch (currentPage) {
      case "OO":
        nextPage = "AA";
        this.setState({ tabActive: nextPage });
        break;
      case "AA": // Page1 START
        // 題1 **[目前非就業中] 先跳題7再跳題10/11/12 / ** [家管/料理家務者] 跳題10/11/12
        switch (value) {
          case "5A16":
            nextPage = "AK"; //第10題
            this.setState({ tabActive: nextPage });
            break;
          case "5A17":
            nextPage = "AH"; //第7題
            this.setState({ tabActive: nextPage });
            break;
          default:
            if (value !== "-1") {
              // 選擇[其他]
              if (value === "5A7" || value === "5A15") {
                let data = this.handle_get_value(currentPage, "selffill");
                //console.log(data)
                if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
                  message.info("請在[其他]欄中輸入說明");
                } else {
                  nextPage = "AB";
                  this.setState({ tabActive: nextPage });
                }
              } else {
                // 選擇[就業]

                // 選擇[部分工時]
                if (
                  value === "5A9" ||
                  value === "5A10" ||
                  value === "5A11" ||
                  value === "5A12" ||
                  value === "5A13" ||
                  value === "5A14"
                ) {
                  if (this.handle_get_value(currentPage, "supplementanswer")) {
                    nextPage = "AB";
                    this.setState({ tabActive: nextPage });
                  } else {
                    message.info("請在每週總工時");
                  }
                } else {
                  nextPage = "AB";
                  this.setState({ tabActive: nextPage });
                }
              }
            } else {
              message.info("未選擇任何答案");
            }
        }
        break;
      case "AB":
        switch (value) {
          case "5B22":
            // 選擇[填充]
            let data = this.handle_get_value(currentPage, "selffill");
            //console.log(data)
            if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
              message.info("請在空白欄中輸入說明");
            } else {
              nextPage = "AC";
              this.setState({ tabActive: nextPage });
            }
            break;
          default:
            if (value !== "-1") {
              nextPage = "AC";
              this.setState({ tabActive: nextPage });
            } else {
              message.info("未選擇任何答案");
            }
        }
        break;
      case "AC":
        switch (value) {
          case "5C1":
            // 選擇[填充]
            let data = this.handle_get_value(currentPage, "selffill");
            //console.log(data)
            if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
              message.info("請在空白欄中輸入說明");
            } else {
              nextPage = "AD";
              this.setState({ tabActive: nextPage });
            }
            break;
          default:
            if (value !== "-1") {
              nextPage = "AD";
              this.setState({ tabActive: nextPage });
            } else {
              message.info("未選擇任何答案");
            }
        }
        break;
      case "AD":
        if (value !== "-1") {
          nextPage = "AF";
          this.setState({ tabActive: nextPage });
        } else {
          message.info("未選擇任何答案");
        }
        break;
      case "AF":
        if (value !== "-1") {
          nextPage = "AG";
          this.setState({ tabActive: nextPage });
        } else {
          message.info("未選擇任何答案");
        }
        break;
      case "AG":
        switch (value) {
          case "5G23":
          case "5G24":
          case "5G25":
          case "5G26":
          case "5G27":
          case "5G28":
          case "5G29":
          case "5G30":
            // 選擇[填充]
            let data = this.handle_get_value(currentPage, "selffill");
            //console.log(data)
            if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
              message.info("請在空白欄中輸入國名");
            } else {
              nextPage = "AI";
              this.setState({ tabActive: nextPage });
            }
            break;
          default:
            if (value !== "-1") {
              nextPage = "AI";
              this.setState({ tabActive: nextPage });
            } else {
              message.info("未選擇任何答案");
            }
        }
        break;
      case "AH": // Page 7
        if (value !== "-1") {
          switch (value) {
            case "5H8": //尋找工作中
            case "5H9":
            case "5H10":
            case "5H11":
            case "5H12":
            case "5H13":
            case "5H14":
            case "5H15":
              let supplementanswer = this.handle_get_value(
                currentPage,
                "supplementanswer"
              );
              if (supplementanswer === "") {
                message.info("請在[目前已花多久時間找工作]中選擇一項");
              } else {
                // 選擇[其他]
                if (value === "5H15") {
                  let data = this.handle_get_value(currentPage, "selffill");
                  //console.log(data)
                  if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
                    message.info("請在[其他]欄中輸入說明");
                  } else {
                    nextPage = "AK";
                    this.setState({ tabActive: nextPage });
                  }
                } else {
                  nextPage = "AK";
                  this.setState({ tabActive: nextPage });
                }
              }
              break;
            default:
              // 選擇[其他]
              if (value === "5H7" || value === "5H22") {
                let data = this.handle_get_value(currentPage, "selffill");
                //console.log(data)
                if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
                  message.info("請在[其他]欄中輸入說明");
                } else {
                  nextPage = "AK";
                  this.setState({ tabActive: nextPage });
                }
              } else {
                nextPage = "AK";
                this.setState({ tabActive: nextPage });
              }
          }
        } else {
          message.info("未選擇任何答案");
        }
        break;
      case "AI":
        if (value !== "-1") {
          nextPage = "AJ";
          this.setState({ tabActive: nextPage });
        } else {
          message.info("未選擇任何答案");
        }
        break;
      case "AJ":
        if (value.length === 0) {
          message.info("未選擇任何答案");
        } else if (value.length > 3) {
          message.info("超過3個選項");
        } else {
          // 選擇其他
          if (value.indexOf("5J10") > -1) {
            let data = this.handle_get_value(currentPage, "selffill");
            if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
              message.info("請在[其他]中輸入說明");
            } else {
              nextPage = "AK";
              this.setState({ tabActive: nextPage });
            }
          } else {
            nextPage = "AK";
            this.setState({ tabActive: nextPage });
          }
        }
        break;
      case "AK": // Page 10
        if (value.length === 0) {
          message.info("未選擇任何答案");
        } else if (value.length > 3) {
          message.info("超過3個選項");
        } else {
          // 選擇其他
          if (value.indexOf("5K12") > -1) {
            let data = this.handle_get_value(currentPage, "selffill");
            if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
              message.info("請在[其他]中輸入說明");
            } else {
              nextPage = "AL";
              this.setState({ tabActive: nextPage });
            }
          } else {
            nextPage = "AL";
            this.setState({ tabActive: nextPage });
          }
        }
        break;
      case "AL": // Page 11
        if (value.length === 0) {
          message.info("未選擇任何答案");
        } else if (value.length > 3) {
          message.info("超過3個選項");
        } else {
          // 選擇其他
          if (value.indexOf("5L12") > -1) {
            let data = this.handle_get_value(currentPage, "selffill");
            if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
              message.info("請在[其他]中輸入說明");
            } else {
              nextPage = "AM";
              this.setState({ tabActive: nextPage });
            }
          } else {
            nextPage = "AM";
            this.setState({ tabActive: nextPage });
          }
        }
        break;
      case "AM": // Page 12 END
        if (value !== "-1") {
          nextPage = "AN";
          this.setState({ tabActive: nextPage });
          this.handle_reply_verification();
        } else {
          message.info("未選擇任何答案");
        }
        break;
      default:
      //  console.log(this.state.investigations)
    }

    // 跳頁設定
    // 將本頁關閉
    this.handle_set_value(currentPage, "disabled", false);
    // 將下頁開啟
    this.handle_set_value(this.state.tabActive, "disabled", true);
  };

  handle_ui_tab_jump = (upPage) => {
    if (upPage === "AJ") {
      const firstPageAnswer = this.handle_get_value("AA", "answer");
      if (firstPageAnswer === "5A16") {
        this.setState({ tabActive: "AA" });
      } else if (firstPageAnswer === "5A17") {
        this.setState({ tabActive: "AH" });
      } else {
        this.setState({ tabActive: upPage });
      }
    } else {
      this.setState({ tabActive: upPage });
    }
  };

  handle_ui_field_process = (type, question_number, target_field, e) => {
    switch (type) {
      case "checkbox":
        this.handle_set_value(question_number, target_field, e);
        break;
      default:
        this.handle_set_value(question_number, target_field, e.target.value);
        break;
    }
  };

  handle_ui_openNotification = (content) => {
    notification.open({
      message: "描述說明",
      description: content,
      onClick: () => {
        //console.log('Notification Clicked!');
      },
    });
  };

  /////////////////////////////////////////////////////////////////////

  render() {
    const { testYear, tabPosition, tabActive, investigations } = this.state;

    const radioStyle = {
      display: "block",
      height: "30px",
      lineHeight: "30px",
    };
    const otherstyles = {
      border: "1px",
      borderBottomStyle: "solid",
      borderTopStyle: "none",
      borderLeftStyle: "none",
      borderRightStyle: "none",
    };

    const options = this.get_list_options;

    return (
      <Card>
        {testYear !== "" ? (
          <Tabs
            tabPosition={tabPosition}
            defaultActiveKey="OO"
            activeKey={tabActive}
            size="small"
          >
            <TabPane
              tab={investigations[0]["tabname"]}
              key={investigations[0]["label"]}
              disabled={investigations[0]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[0]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[0]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[1]["label"])
                      }
                    >
                      開始
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Typography>
                    <Title>親愛的畢業校友，您好</Title>
                    <Paragraph>
                      大專畢業後五年的您，現況如何？母校十分關心您，希望瞭解您的現況與感想。本項調查結果將提供母校辦學及校務發展改善、系所學位學程課程規劃及高等教育人才培育相關政策研議之參考。
                    </Paragraph>
                    <Paragraph>
                      您的意見十分重要，懇請耐心協助填答。本調查不會影響您任何權益，但請勿轉由他人代為填答。母校由衷希望您能撥冗回覆本調查。
                      本問卷結果將依個人資料保護法規定嚴密保管與遵循法令規定處理，並提供以下單位進行後續運用，以及避免重複向您蒐集資料，敬請放心填答。
                    </Paragraph>
                    <Paragraph>
                      <ul>
                        <li>
                          <Text>提供教育部進行教育政策研議與分析…等事項。</Text>
                        </li>
                        <li>
                          <Text>
                            提供學校辦理教學改進、服務追蹤、資訊交流及未來校友服務…等事項。
                          </Text>
                        </li>
                      </ul>
                    </Paragraph>
                    <Paragraph>
                      如對本問卷填答有任何疑問或需依個人資料保護法第3條規定行使相關權利時，歡迎以E-Mail或電話與我們聯絡。感謝您的填答！
                    </Paragraph>
                    <Paragraph>
                      <ul>
                        <li>
                          <Text>
                            承辦單位：
                            <Link href="https://cds-rd.tut.edu.tw/">
                              研發處/職涯發展中心
                            </Link>
                          </Text>
                        </li>
                        <li>
                          <Text>
                            聯絡電話：
                            <Link href="TEL:06-2421971">
                            06-2421971
                            </Link>
                          </Text>
                        </li>
                        <li>
                          <Text>
                            E-Mail：
                            <Link href="mailto:emtalk@mail.tut.edu.tw">
                            emtalk@mail.tut.edu.tw
                            </Link>
                          </Text>
                        </li>
                      </ul>
                    </Paragraph>
                  </Typography>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[1]["tabname"]}
              key={investigations[1]["label"]}
              disabled={investigations[1]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[1]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[1]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <Button
                    type="primary"
                    onClick={() =>
                      this.handle_ui_tab_process(
                        investigations[1]["label"],
                        investigations[1]["answer"]
                      )
                    }
                  >
                    下一題
                  </Button>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[1]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    <Divider orientation="left">A.全職工作</Divider>
                    {options(investigations[1]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "A") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[1]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">B.部份工時</Divider>
                    {options(investigations[1]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "B1") {
                        return (
                          <p>
                            B.1.{item["content"]}
                            <Input
                              placeholder=""
                              style={Object.assign({}, otherstyles, {
                                width: "50px",
                              })}
                              onChange={(e) =>
                                this.handle_ui_field_process(
                                  "input",
                                  investigations[1]["label"],
                                  "supplementanswer",
                                  e
                                )
                              }
                            />
                            小時<Text mark>(建議以每週平均時數填報)</Text>
                          </p>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left"></Divider>
                    <p>
                      <Text disabled strong>
                        B.2.若同時有多份Part
                        Time工作，請以主要工作時數較長者作答
                      </Text>
                    </p>
                    {options(investigations[1]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "B2") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[1]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">C.家管</Divider>
                    {options(investigations[1]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "C") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[1]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">D.非就業</Divider>
                    {options(investigations[1]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "D") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[1]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[2]["tabname"]}
              key={investigations[2]["label"]}
              disabled={investigations[2]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[2]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[2]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[1]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[2]["label"],
                          investigations[2]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[2]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[2]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[2]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[3]["tabname"]}
              key={investigations[3]["label"]}
              disabled={investigations[3]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[3]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[3]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[2]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[3]["label"],
                          investigations[3]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[3]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[3]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <>
                                <Input
                                  placeholder=""
                                  style={Object.assign({}, otherstyles, {
                                    width: "50px",
                                  })}
                                  onChange={(e) =>
                                    this.handle_ui_field_process(
                                      "input",
                                      investigations[3]["label"],
                                      "selffill",
                                      e
                                    )
                                  }
                                />
                                人
                              </>
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[4]["tabname"]}
              key={investigations[4]["label"]}
              disabled={investigations[4]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[4]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[4]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[3]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[4]["label"],
                          investigations[4]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[4]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[4]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[4]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[5]["tabname"]}
              key={investigations[5]["label"]}
              disabled={investigations[5]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[5]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[5]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[4]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[5]["label"],
                          investigations[5]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[5]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[5]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[5]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[6]["tabname"]}
              key={investigations[6]["label"]}
              disabled={investigations[6]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[6]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[6]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[5]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[6]["label"],
                          investigations[6]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[6]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    <Divider orientation="left">境內</Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">北部地區</Text>
                      </p>
                    </Title>
                    {options(investigations[6]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "A") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="國名"
                                style={Object.assign({}, otherstyles, {
                                  width: "60px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[6]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left"></Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">中部地區</Text>
                      </p>
                    </Title>
                    {options(investigations[6]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "B") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="國名"
                                style={Object.assign({}, otherstyles, {
                                  width: "60px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[6]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left"></Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">南部地區</Text>
                      </p>
                    </Title>
                    {options(investigations[6]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "C") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="國名"
                                style={Object.assign({}, otherstyles, {
                                  width: "60px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[6]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left"></Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">東部、離島及其他地區</Text>
                      </p>
                    </Title>
                    {options(investigations[6]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "D") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="國名"
                                style={Object.assign({}, otherstyles, {
                                  width: "60px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[6]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">境外(請填報工作國家別)</Divider>
                    {options(investigations[6]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "E") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="國名"
                                style={Object.assign({}, otherstyles, {
                                  width: "60px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[6]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[7]["tabname"]}
              key={investigations[7]["label"]}
              disabled={investigations[7]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[7]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[7]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[0]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[7]["label"],
                          investigations[7]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[7]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    <Divider orientation="left">A.進修</Divider>
                    {options(investigations[7]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "A") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[7]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">B.服役</Divider>
                    {options(investigations[7]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "B") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[7]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">C.準備考試</Divider>
                    {options(investigations[7]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "C") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[7]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">D.尋找工作中</Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">
                          D.1.到現在還在尋找工作的最大可能原因為何
                        </Text>
                      </p>
                    </Title>
                    {options(investigations[7]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "D1") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[7]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left"></Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">D.2.目前已花多久時間找工作</Text>
                      </p>
                    </Title>
                    <Radio.Group
                      onChange={(e) =>
                        this.handle_ui_field_process(
                          "radio",
                          investigations[7]["label"],
                          "supplementanswer",
                          e
                        )
                      }
                    >
                      {options(investigations[7]["label"]).map(
                        (item, index) => {
                          if (item["groupvalue"] === "D2") {
                            return (
                              <Radio
                                style={radioStyle}
                                value={item["choicevalue"]}
                                key={index}
                              >
                                {item["content"]}
                                {item["canselffill"] === "Y" ? (
                                  <Input
                                    placeholder="請說明"
                                    style={Object.assign({}, otherstyles, {
                                      width: "150px",
                                      height: "30px",
                                    })}
                                    onChange={(e) =>
                                      this.handle_ui_field_process(
                                        "input",
                                        investigations[7]["label"],
                                        "selffill",
                                        e
                                      )
                                    }
                                  />
                                ) : (
                                  ""
                                )}
                                {item["description"] ? (
                                  <Button
                                    type="link"
                                    shape="circle"
                                    icon={<QuestionCircleOutlined />}
                                    onClick={() =>
                                      this.handle_ui_open_notification(
                                        item["description"]
                                      )
                                    }
                                  ></Button>
                                ) : (
                                  ""
                                )}
                                {item["details"]
                                  ? item["details"].map((tag, index) => (
                                      <Tag key={index}>{tag}</Tag>
                                    ))
                                  : ""}
                              </Radio>
                            );
                          } else {
                            return true;
                          }
                        }
                      )}
                    </Radio.Group>
                    <Divider orientation="left">E.其他</Divider>
                    {options(investigations[7]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "E") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[7]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[8]["tabname"]}
              key={investigations[8]["label"]}
              disabled={investigations[8]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[8]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[8]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[6]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[8]["label"],
                          investigations[8]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[8]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[8]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[8]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[9]["tabname"]}
              key={investigations[9]["label"]}
              disabled={investigations[9]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[9]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[9]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[8]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[9]["label"],
                          investigations[9]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Checkbox.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "checkbox",
                        investigations[9]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[9]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Checkbox
                            style={radioStyle}
                            label={item["content"]}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[9]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] !== "" ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Checkbox>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Checkbox.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[10]["tabname"]}
              key={investigations[10]["label"]}
              disabled={investigations[10]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[10]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[10]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[9]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[10]["label"],
                          investigations[10]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Checkbox.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "checkbox",
                        investigations[10]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[10]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Checkbox
                            style={radioStyle}
                            label={item["content"]}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[10]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] !== "" ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Checkbox>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Checkbox.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[11]["tabname"]}
              key={investigations[11]["label"]}
              disabled={investigations[11]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[11]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[11]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[10]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[11]["label"],
                          investigations[11]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Checkbox.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "checkbox",
                        investigations[11]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[11]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Checkbox
                            style={radioStyle}
                            label={item["content"]}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[11]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] !== "" ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Checkbox>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Checkbox.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[12]["tabname"]}
              key={investigations[12]["label"]}
              disabled={investigations[12]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[12]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[12]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[12]["label"],
                          investigations[12]["answer"]
                        )
                      }
                    >
                      送出問卷
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[12]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[12]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[12]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[13]["tabname"]}
              key={investigations[13]["label"]}
              disabled={investigations[13]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>謝謝您的填答</Title>
                  </>
                }
              >
                <List.Item></List.Item>
              </List>
            </TabPane>
          </Tabs>
        ) : (
          <Alert message="非滿畢業五年調查對象" type="warning" closable />
        )}
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(SurveyFiveYear);
